import React from "react";
import "./LivingAreaCleaningService.css";

const LivingAreaCleaningService = () => {
  return (
    <div className="livingareacleaning-cleaning-container">
      <h1>Tidy, Comfortable, and Inviting Living Spaces</h1>
      <p>
        We'll dust all surfaces, vacuum or mop floors, and clean any mirrors or
        windows.
      </p>
      <h2>What’s Included:</h2>
      <ul>
        <li>Dust all surfaces</li>
        <li>Vacuum or mop floors</li>
        <li>Clean mirrors and windows</li>
      </ul>
    </div>
  );
};

export default LivingAreaCleaningService;
